import { useState, useEffect } from "react";
import photo1 from "../assets/IMG_2101.jpeg";
import photo2 from "../assets/artist-photo.png";
import photo3 from "../assets/IMG_2104.jpeg";
import photo4 from "../assets/IMG_2105.jpeg";

const PHOTOS = [photo1, photo2, photo3, photo4];
const TITLE_LETTERS = "MOODE.ART".split("");

export function Hero() {
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPhotoIndex((i) => (i + 1) % PHOTOS.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden flex items-end px-6 pb-16 md:px-13 md:pb-20">
      {PHOTOS.map((photo, i) => (
        <div
          key={i}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-2000"
          style={{ backgroundImage: `url(${photo})`, opacity: i === photoIndex ? 1 : 0 }}
        />
      ))}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_top,rgba(0,0,0,0.85)_0%,rgba(0,0,0,0.2)_50%,rgba(0,0,0,0.5)_100%)]" />
      <div className="absolute left-1/2 -translate-x-1/2 md:left-30 md:translate-x-0 top-16 md:top-18 text-2xl font-bold tracking-wider text-center">
        ELECTRONIC MUSIC PROJECT
      </div>
      <div className="absolute left-6 md:left-13 top-1/2 -translate-y-1/2 flex items-start gap-20 z-1">
        <div className="h-[70vh] flex flex-col justify-between">
          {TITLE_LETTERS.map((letter, i) => (
            <span
              key={i}
              className="text-[clamp(28px,5vh,90px)] font-bold tracking-wider leading-none text-primary"
            >
              {letter}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-10 right-6 md:right-13 z-1 flex flex-col items-center gap-3">
        <span className="[writing-mode:vertical-rl] text-[9px] tracking-[0.3em] uppercase text-muted">
          Scroll
        </span>
        <div className="h-12 w-px overflow-hidden">
          <div className="scroll-line w-px h-full bg-muted" />
        </div>
      </div>
    </section>
  );
}
